// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"pB-z","expressButtonContainerWithPayPal":"qB-z","expressButton":"rB-z","or":"sB-z"};